export const CDN_BASE_URL = 'https://cdnsm.swipey.ai';
export const SWIPEY_BASE_URL = process.env.REACT_APP_SWIPEY_BASE_URL;

export const DEFAULT_GIRLS_SLUGS = [
  'mia_andersen',
  'olivia_smith',
  'geronica_johnson',
  'sara_rahman',
  'han_kim',
  'amina_walker',
  'albina',
  'emely_snow',
  'miki_sato',
  'sofia_solis',
  'sophie_willow',
  'nyx',
];
